<template>
  <div class="article-detail">
    <h4 class="title">{{ articleDetail.title }}</h4>
    <div class="publish-wrapper">
      <img class="publish-img" src="~@/assets/image/plus_logo.png" alt="" />
      <div class="publish-content">
        <span>{{ articleDetail.publishName }}</span>
        <div class="read-count-wrapper">
          <span>{{ articleDetail.plusEffectDate }}</span>
          <van-icon
            name="eye-o"
            style="margin-left: 15px"
            v-if="articleDetail && articleDetail.isRead == 1"
          />
          <span
            class="read-count"
            v-if="articleDetail && articleDetail.isRead == 1"
            >{{
              (articleDetail.plusClickSum || 0) +
              (articleDetail.plusRealClickSum || 0)
            }}</span
          >
        </div>
      </div>
    </div>
    <div class="intro" v-if="articleDetail.absTract">
      <div v-html="articleDetail.absTract"></div>
    </div>
    <div
      id="content"
      class="content"
      v-html="articleDetail.content"
      @click="handleClickContent"
    ></div>
    <div class="info-name">{{ articleDetail.reporterName }}</div>
    <div class="info-name">{{ articleDetail.messenger }}</div>
    <div class="info-name">{{ articleDetail.editorName }}</div>
    <div class="info-name">{{ articleDetail.commentator }}</div>
    <div class="info-name">{{ articleDetail.from }}</div>

    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="已经到底了"
      @load="commentOnLoad"
      class="article-list"
      v-if="commentList.length"
    >
      <div class="comments-wrapper">
        <div class="divider">
          <span class="divider-left"></span>
          <span class="divider-desc">全部评论</span>
          <span class="divider-left"></span>
        </div>
        <div class="comment-list">
          <div class="comment-item" v-for="item in commentList" :key="item.id">
            <div class="comment-info">
              <van-image
                width="35"
                height="35"
                class="parent-img"
                round
                :src="item.userPersonalImage"
              />
              <div class="right-info">
                <div class="nick-wrapper">
                  <span class="nickname">{{ item.userNickname }}</span>
                  <div class="like-wrapper">
                    <van-icon name="like" />
                    {{ item.praiseSum }}
                  </div>
                </div>
                <span>{{ formatMsgTime(item.publishDate) }}</span>
              </div>
            </div>
            <div class="content-info">
              {{ item.content }}
            </div>
            <div class="child-comment" v-if="item.childCommentList.length">
              <div
                class="child-item"
                v-for="child in item.childCommentList"
                :key="child.id"
              >
                <div class="comment-info">
                  <van-image
                    width="30"
                    height="30"
                    class="child-img"
                    round
                    :src="child.userPersonalImage"
                  />
                  <div class="right-info">
                    <div class="nick-wrapper">
                      <span class="nickname">{{ child.userNickname }}</span>
                      <div class="like-wrapper">
                        <van-icon name="like" />
                        {{ child.praiseSum }}
                      </div>
                    </div>
                    <!-- <span class="nickname">{{ child.userNickname }}</span> -->
                    <span>{{ child.publishDate }}</span>
                  </div>
                </div>
                <div class="content-info">
                  {{ child.content }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-list>
    <div v-else>
      <div class="comments-wrapper">
        <div class="divider">
          <span class="divider-left"></span>
          <span class="divider-desc">全部评论</span>
          <span class="divider-left"></span>
        </div>
        <van-empty description="暂无评论" />
      </div>
    </div>
  </div>
</template>

<script>
import { ImagePreview } from "vant";
import { getPlusArticle, queryAllComments } from "@/http/api";

export default {
  name: "PlusArticle",
  data() {
    return {
      imgList: [],
      operateId: null,
      articleDetail: {},

      commentList: [],
      loading: false,
      finished: false,
      commentPageNum: 1,
    };
  },
  async mounted() {
    this.init();
    this.queryCommentData();
  },
  updated() {
    let obj = document.getElementById("content");
    let imgs = obj.getElementsByTagName("img");
    if (imgs.length > 0) {
      this.imgList = [];
      for (let i = 0; i < imgs.length; i++) {
        this.imgList.push(imgs[i].src);
      }
    }
  },
  methods: {
    init() {
      let path = this.$route.path;
      let pathArr = path.split("/");
      this.operateId = pathArr[pathArr.length - 1];
      this.getArticleDetail();
      const link =
        document.querySelector("link[rel*='icon']") ||
        document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "shortcut icon";
      link.href = require("@/assets/image/plus_logo.png");
      document.getElementsByTagName("head")[0].appendChild(link);
    },
    getArticleDetail() {
      getPlusArticle(this.operateId).then((res) => {
        const data = res.data;
        data.absTract = data.absTract ? data.absTract.trim() : null;
        this.articleDetail = data;

        document.title = this.articleDetail.title
          ? this.articleDetail.title
          : "花城+";
      });
    },
    handleClickContent(e) {
      if (e.target.nodeName === "IMG") {
        let handleImgIndex = this.imgList.findIndex((value) => {
          return value === e.target.src;
        });
        ImagePreview({
          images: this.imgList,
          startPosition: handleImgIndex,
        });
      }
    },
    async queryCommentData() {
      this.loading = true;
      const { data } = await queryAllComments({
        operateId: this.operateId,
        operateType: 1,
        pageNum: this.commentPageNum,
        pageSize: 10,
      });
      this.loading = false;
      if (this.commentPageNum >= data.pages) {
        this.finished = true;
      }
      this.commentList = [...this.commentList, ...data.records];
    },

    commentOnLoad() {
      this.commentPageNum++;
      this.queryCommentData();
    },
    formatMsgTime(dateTimeStamp) {
      // 时间字符串转时间戳 获取毫秒数
      let timestamp = new Date(dateTimeStamp.replace(/-/g, "/")).getTime();
      let minute = 1000 * 60;
      let hour = minute * 60;
      let day = hour * 24;
      let halfamonth = day * 15;
      let month = day * 30;
      let year = day * 365;
      let now = new Date().getTime();
      let diffValue = now - timestamp;
      let result;
      if (diffValue < 0) {
        return;
      }
      let yearC = diffValue / year;
      let monthC = diffValue / month;
      let weekC = diffValue / (7 * day);
      let dayC = diffValue / day;
      let hourC = diffValue / hour;
      let minC = diffValue / minute;
      if (yearC >= 1) {
        result = "" + parseInt(yearC) + "年前";
      } else if (monthC >= 1) {
        result = "" + parseInt(monthC) + "月前";
      } else if (weekC >= 1) {
        result = "" + parseInt(weekC) + "周前";
      } else if (dayC >= 1) {
        result = "" + parseInt(dayC) + "天前";
      } else if (hourC >= 1) {
        result = "" + parseInt(hourC) + "小时前";
      } else if (minC >= 1) {
        result = "" + parseInt(minC) + "分钟前";
      } else result = "刚刚";
      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
/* @import "@/assets/scss/index.scss"; */
.article-detail {
  position: relative;
  /* font-size: 14px; */
  box-sizing: border-box;
  padding: 0 15px;
  width: 100%;
  overflow: hidden !important;
  font-size: 18px;
  font-family: FZBiaoYaSong-GBK_YS !important;

  .title {
    font-size: 1.35rem;
    font-weight: 600;
    line-height: 1.65;
    text-align: left;
    font-family: Microsoft YaHei !important;
  }
  .publish-wrapper {
    display: flex;
    height: 42px;
    margin-top: 15px;

    .publish-img {
      width: 42px;
      height: 42px;
      border-radius: 50%;
    }

    .publish-content {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-left: 10px;
      font-size: 14px;
      box-sizing: border-box;
      padding: 2px 0;

      .read-count-wrapper {
        display: flex;
        align-items: center;
        gap: 4px;
        // font-size: 12px;
        // color: #999;

        .read-count {
          // font-weight: 500;
          // color: #666;
        }

        .van-icon {
          font-size: 20px;
        }
      }
    }
  }

  .intro {
    position: relative;
    background: #f9f9f9;
    font-size: 16px;
    padding: 15px;
    margin: 10px 0;
    border-radius: 4px;
    color: #666;
    box-sizing: border-box;

    &::before {
      position: absolute;
      content: "“";
      top: 0;
      left: 0;
      transform: translate(-30%, -20%);
      font-size: 32px;
      color: #bcd7e4;
      font-weight: bold;
      font-family: SimHei;
    }

    &::after {
      position: absolute;
      content: "”";
      bottom: 0;
      right: 0;
      transform: translate(30%, 75%);
      font-size: 32px;
      color: #bcd7e4;
      font-weight: bold;
      font-family: SimHei;
    }
  }

  .content {
    overflow-x: hidden;
    margin-top: 10px;
    width: 100%;
  }
  .content p {
    line-height: 1.75;
    margin: 0;
    padding-bottom: 1em;
  }

  .info-name {
    margin-top: 5px;

    &:last-child {
      margin-bottom: 20px;
    }
  }

  .comments-wrapper {
    margin-top: 20px;

    .divider {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 20px 0;

      &-left {
        width: 100px;
        height: 1px;
        background: rgba(220, 220, 220, 0.9);
        transform: scaleY(0.5);
      }

      &-desc {
        margin: 0 15px;
        font-size: 14px;
        font-weight: bold;
      }
    }

    .comment-list {
      width: 100%;

      .comment-item {
        margin-bottom: 20px;

        .comment-info {
          display: flex;
          align-items: center;

          .parent-img {
            width: 35px;
            min-width: 35px;
            height: 35px;
            border-radius: 50%;
          }

          .right-info {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: 100%;
            height: 35px;
            color: #999;
            font-size: 12px;
            margin-left: 10px;

            .nick-wrapper {
              display: flex;
              width: 100%;
              align-items: center;
              justify-content: space-between;

              .nickname {
                color: #333;
                font-size: 14px;
                font-weight: bold;
              }

              .like-wrapper {
                font-size: 16px;
              }
            }
          }
        }

        .content-info {
          margin-left: 45px;
          margin-top: 5px;
          font-size: 14px;
          word-break: break-all;
        }

        .child-comment {
          margin-left: 45px;
          margin-top: 10px;
          background: #f9f9f9;
          box-sizing: border-box;
          padding: 8px;
          border-radius: 6px;

          .child-item {
            margin-bottom: 20px;

            &:last-child {
              margin-bottom: 0;
            }

            .comment-info {
              display: flex;
              align-items: center;

              .child-img {
                width: 30px;
                min-width: 30px;
                height: 30px;
                border-radius: 50%;
              }

              .right-info {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                height: 30px;
                width: 100%;
                color: #999;
                font-size: 12px;
                margin-left: 10px;

                .nick-wrapper {
                  display: flex;
                  width: 100%;
                  align-items: center;
                  justify-content: space-between;

                  .nickname {
                    color: #333;
                    font-size: 14px;
                    font-weight: bold;
                  }

                  .like-wrapper {
                    font-size: 16px;
                  }
                }
              }
            }

            .content-info {
              margin-left: 45px;
              margin-top: 5px;
              font-size: 14px;
              word-break: break-all;
              color: #333;
            }
          }
        }
      }
    }
  }
}
</style>
